import Box from '@mui/material/Box';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export const MarkdownText = ({ children }) => (
  <Box
    sx={{
      fontSize: 14,
      '& p': { m: 0.5 },
      '& ul': { pl: 2, m: 0.5 },
      '& ol': { pl: 2, m: 0.5 },
      '& h1, & h2, & h3': { m: 0.5, fontSize: '1.1em' },
      '& pre': { bgcolor: 'action.hover', p: 1, borderRadius: 1 },
      '& a': { color: 'primary.main' },
      '& table': { borderCollapse: 'collapse', my: 0.5 },
      '& th, & td': { border: 1, borderColor: 'divider', px: 1, py: 0.5, fontSize: 12 },
      '& input[type="checkbox"]': { mr: 0.5 },
    }}
  >
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{children || ''}</ReactMarkdown>
  </Box>
);
